// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ddec5fa9","455":"86f070ff"}[chunkId] + ".chunk.js";
};